import { css } from 'lit';

export const q1VersionHistoryStyles = css`

  :host {
    display: block;
  }

  #base-container {
    display: block;
  }

  /*=== SL DETAILS ===*/

  sl-details::part(base) {
    border-radius: 12px;
    background: var(--gray-0);
    border: 1px solid var(--gray-2);
    overflow: hidden;
  }
  sl-details::part(header) {
    padding: 1.5rem;
    border-bottom: 1px solid var(--gray-1);
  }
  sl-details::part(summary) {
    font-size: 1.2rem;
    font-weight: 400;
    transition: all 0.2s ease-in-out;
  }
  sl-details::part(content) {
    padding: 0 0 0.25rem 0;
  }

  sl-details[open]::part(base) {
    background: white;
    box-shadow: var(--sl-shadow-small);
  }
  sl-details[open]::part(summary) {
    font-weight: 600;
  }

  span[slot='summary'] {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  /*=== TABLE ===*/

  table-wrapper {
    display: block;
    overflow: auto;
  }

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: none;

    --table-edge-cell-padding: 1.5rem;
    --table-cell-padding: 1rem 1rem;
    --table-border: 1px solid var(--gray-1);
    --table-cell-bg: white;
  }

  table th {
    text-align: left;
    font-size: 1rem;
    line-height: 1.3em;
    font-weight: 300;
    font-style: italic;
    color: var(--gray-6);

    padding: var(--table-cell-padding);
    border-bottom: var(--table-border);
    background: var(--table-cell-bg);
  }
  table th:first-child {
    padding-left: var(--table-edge-cell-padding);
  }
  table th:last-child {
    padding-right: var(--table-edge-cell-padding);
  }

  table td {
    font-size: 1rem;
    line-height: 1.3em;
    font-weight: 400;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    padding: var(--table-cell-padding);
    background: var(--table-cell-bg);
  }
  table td:first-child {
    padding-left: var(--table-edge-cell-padding);
  }
  table td:last-child {
    padding-right: var(--table-edge-cell-padding);
  }
  table tr:not(:last-child) td {
    border-bottom: var(--table-border);
  }

  tr.empty-placeholder td .td-inner {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--gray-6);
    font-size: 1rem;
    line-height: 1.5em;
    font-weight: 300;
    font-style: italic;
    margin: 0.5rem 0;
  }
  tr.empty-placeholder.error td .td-inner {
    color: var(--red-4);
  }

  tr.proposed td.title-col {
    font-style: italic;
  }

  td.status-col {
    color: var(--gray-6);
  }
  td.status-col sl-icon {
    font-size: 1.3rem;
  }
  
  td.status-col sl-icon.draft { color: var(--gray-6); }
  td.status-col sl-icon.locked { color: var(--gray-7); }
  td.status-col sl-icon.adopted { color: var(--green-5); }
  td.status-col sl-icon.replaced { color: var(--gray-5); }
  td.status-col sl-icon.abandoned { color: var(--gray-5); }

  td.status-col sl-icon.proposed { color: var(--gray-7); }
  td.status-col sl-icon.approved { color: var(--green-5); }
  td.status-col sl-icon.auto-approved { color: var(--green-5); }
  td.status-col sl-icon.declined { color: var(--red-3); }

  .td-inner {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  span.divider {
    font-weight: 100;
    color: var(--gray-5);
  }

  /*=== LINKS ===*/

  a {
    color: var(--link-color-default, var(--blue-7));
    text-decoration: var(--link-text-decoration-default, underline);
    font-weight: var(--link-font-weight-default, normal);
    transition: all 0.2s ease-in-out;
  }
  a:visited {
    color: var(--link-color-visited, var(--blue-8));
  }
  a:focus, a:hover {
    color: var(--link-color-focus, var(--blue-9));
    font-weight: var(--link-font-weight-focus, var(--link-font-weight-default, normal));
    text-decoration: var(--link-text-decoration-focus, underline);
  }

  a.title-link {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    --link-color-default: var(--gray-8);
    --link-color-visited: var(--gray-7);
    --link-color-focus: var(--gray-9);
    --link-text-decoration-default: none;
    --link-text-decoration-focus: underline;
  }
  tr.current-version a.title-link {
    font-weight: 600;
  }

`;
